/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';
import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import RemoveIcon from '@mui/icons-material/Remove';
import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Col, Row, Button } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import TextInput from 'components/input/textInput';
import DatePickerInput from 'components/input/DatePicker';
import GroupCheckbox from 'components/input/GroupCheckbox';
import SelectInput from 'components/input/SelectInput';
import { csuCountry, formatDate, notUsCountry, optionValues2 } from 'components/helper/helper';
import moment from 'moment';
import YesNoSwitch from 'components/input/YesNoSwitch';
import collegeServices from 'services/collegeServices';
import GroupRadioButton from 'components/input/GroupRadioButton';
import { collegeDetailEarnedOption, majorOption, earnDegreeYears } from './CollegeConstant';
import CheckboxInput from 'components/input/CheckboxInput';
import { debounce, defer } from 'lodash';
import AutocompleteInput from 'components/input/AutoCompleteInput';
import FormCreateCollegeModal from './FormCreateCollegeModal';
import TextIconInput from 'components/input/TextIconInput';
import LoadingContent from 'components/LoadingContent';
import { canadaProvince, usaState } from 'components/helper/stateAndCounty';
import { countryOptions } from 'components/helper/countryPhoneCode';
import { states_usa } from 'components/helper/state_usa';
import { checkEmptyValue } from 'components/helper/helper';
import Grid from '@mui/joy/Grid';
import { ModalConfirm } from 'screen/common/ModalConfirm';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
//import { tryParseJSON, checkEmptyValue } from 'components/helper/helper';
// import Cookies from 'js-cookie';
// import { getGradeAndCourse, updateGradeAndCourse } from 'app/course/courseSlice';
// import { CollegeCourseConfigInitialType } from 'screen/course/collegeCourse/components/collegeCourse.type';
// import { useAppDispatch } from 'app/hooks';

export const AliasNames = [{ alias: 'miracosta', name: 'Mira Costa' }];

export const UnlistedTypes = [
  'Unlisted English Speaking Canadian Institution',
  'Unlisted US Institution',
  'Unlisted French Speaking Canadian or Other Foreign Institution',
];

export const CollegeSchoolType = ['2-year or community college', '4-year college or university'];

//degree_earned
export const degree_earned_options = [
  { name: 'AA', value: 'AA' },
  { name: 'AS', value: 'AS' },
  { name: 'BA', value: 'BA' },
  { name: 'BS', value: 'BS' },
  { name: 'No degree earned', value: 'No degree earned' },
];

export const month_options = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const loadStates = () => {
  const arr = [{ name: 'State/U.S. territory *', value: 'N/A' }];
  const states = arr.concat(
    states_usa.filter((obj) => {
      return obj.value !== 'CA';
    })
  );

  return states.map((o) => {
    return o.name;
  });
};

export const getStateName = (stateCode: string) => {
  for (let i = 0; i < states_usa.length; i++) {
    if (states_usa[i].value === stateCode) return states_usa[i].name;
  }
  return stateCode;
};

export const grade_options = [
  { value: '' },
  { value: '9th' },
  { value: '10th' },
  { value: '11th' },
  { value: '12th' },
];

export const type_of_term_systerm_options = ['Quarter', 'Semester', 'Trimester'];
export const type_of_term_systerm_uc_options = [
  'Quarter',
  'Semester',
  'Semester with Winter Session',
];
export const tuition_status_options = [
  'In-State Tuition',
  'Out-of-State Tuition',
  'Not applicable',
];
export const grading_system_options = [
  {
    value: 'college_grading_system_alphabet',
    label: 'A B C D F',
  },
  {
    value: 'college_grading_system_other',
    label: `Other`,
  },
];

interface ExpandMoreProps extends IconButtonProps {
  expand: boolean;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

type MaskEditCollegeInfo = {
  ceeb: boolean;
  name: boolean;
  school_type: boolean;
  city: boolean;
  state: boolean;
  zip: boolean;
  country: boolean;
};

export const initialCollegeValues = {
  college_info: {
    where_attend_college: 'IN_CA',
    state: '',
    country: '',
    college_name: '',
    detail_degree_earned: '',
    when_you_earn_degree_year: '',
    when_you_earn_degree_month: '',
    your_major: '',
    your_minor: '',
    have_double_major: false,
    your_second_major: '',
    type_of_term_systerm: '',
    type_of_term_systerm_uc: '',
    your_tuition_status: '',
    unlisted_type: '',
  },
  // where_attend_college: '',
  school: {
    ceeb: '',
    fib_code: '',
    name: '',
    school_type: null,
    city: '',
    state: '',
    zip: '',
    country: '',
    csu_name: '',
    uc_name: '',
    cm_name: '',
    match_all: false,
    label: '',
    code: null,
    is_manual: false,
  } as any,
  //fullName: '',
  college_name: '',
  college_zip_code: '',
  college_city: '',
  college_ceeb: '',
  college_state: '',
  college_country: '',
  csu_name: '',
  fromDate: '',
  toDate: '',
  college_is_dual_enrollment: false,
  college_is_credit_awarded: false,
  college_is_summer_program: false,
  degree_earned: 'No degree earned',
  degree_info: '',
  expect_to_earn_degree_from_San_Diego_Mesa: '',
  grades: [],
  grades_fall: [],
  grades_winter: [],
  grades_spring: [],
  grades_summer: [],
  college_grading_system_alphabet: false,
  college_grading_system_100: false,
  college_grading_system_7: false,
  college_grading_system_other: false,
  lowest_number_grade: '',
  highest_number_grade: '',
  other_grading_system: '',
  isStillAttendingThisCollege: false,
  id: '',
};

const initItem = (item: any) => {
  try {
    if (item) {
      return {
        college_info: item?.college_info ?? {
          where_attend_college: 'IN_CA',
          state: '',
          country: '',
          college_name: '',
          detail_degree_earned: '',
          when_you_earn_degree_year: '',
          when_you_earn_degree_month: '',
          your_major: '',
          your_minor: '',
          have_double_major: false,
          your_second_major: '',
          type_of_term_systerm: '',
          type_of_term_systerm_uc: '',
          your_tuition_status: '',
          unlisted_type: '',
        },
        school: item?.school ?? {
          ceeb: '',
          fib_code: '',
          name: '',
          school_type: null,
          city: '',
          state: '',
          zip: '',
          country: '',
          csu_name: '',
          uc_name: '',
          cm_name: '',
          match_all: false,
          label: '',
          code: null,
          is_manual: false,
        },
        college_name: item?.college_name ?? '',
        college_zip_code: item?.college_zip_code ?? '',
        college_city: item?.college_city ?? '',
        college_ceeb: item?.college_ceeb ?? '',
        college_state: item?.college_state ?? '',
        college_country: item?.college_country ?? '',
        csu_name: item?.csu_name ?? '',
        fromDate: item?.fromDate ?? '',
        toDate: item?.toDate ?? '',
        college_is_dual_enrollment: item?.college_is_dual_enrollment ?? false,
        college_is_credit_awarded: item?.college_is_credit_awarded ?? false,
        college_is_summer_program: item?.college_is_summer_program ?? false,
        degree_earned: item?.degree_earned ?? 'No degree earned',
        degree_info: item?.degree_info ?? '',
        expect_to_earn_degree_from_San_Diego_Mesa:
          item?.expect_to_earn_degree_from_San_Diego_Mesa ?? '',
        grades: [...(item?.grades ?? [])],
        grades_fall: [...(item?.grades_fall ?? [])],
        grades_winter: [...(item?.grades_winter ?? [])],
        grades_spring: [...(item?.grades_spring ?? [])],
        grades_summer: [...(item?.grades_summer ?? [])],
        college_grading_system_alphabet: item?.college_grading_system_alphabet ?? false,
        college_grading_system_100: item?.college_grading_system_100 ?? false,
        college_grading_system_7: item?.college_grading_system_7 ?? false,
        college_grading_system_other: item?.college_grading_system_other ?? false,
        lowest_number_grade: item?.lowest_number_grade ?? '',
        highest_number_grade: item?.highest_number_grade ?? '',
        other_grading_system: item?.other_grading_system ?? '',
        isStillAttendingThisCollege: item?.isStillAttendingThisCollege ?? false,
        id: item?.id ?? '',
      };
    } else {
      return {
        college_info: {
          where_attend_college: 'IN_CA',
          state: '',
          country: '',
          college_name: '',
          detail_degree_earned: '',
          when_you_earn_degree_year: '',
          when_you_earn_degree_month: '',
          your_major: '',
          your_minor: '',
          have_double_major: false,
          your_second_major: '',
          type_of_term_systerm: '',
          type_of_term_systerm_uc: '',
          your_tuition_status: '',
          unlisted_type: '',
        },
        school: {
          ceeb: '',
          fib_code: '',
          name: '',
          school_type: null,
          city: '',
          state: '',
          zip: '',
          country: '',
          csu_name: '',
          uc_name: '',
          cm_name: '',
          match_all: false,
          label: '',
          code: null,
          is_manual: false,
        },
        college_name: '',
        college_zip_code: '',
        college_city: '',
        college_ceeb: '',
        college_state: '',
        college_country: '',
        csu_name: '',
        fromDate: '',
        toDate: '',
        college_is_dual_enrollment: false,
        college_is_credit_awarded: false,
        college_is_summer_program: false,
        degree_earned: 'No degree earned',
        degree_info: '',
        expect_to_earn_degree_from_San_Diego_Mesa: '',
        grades: [],
        grades_fall: [],
        grades_winter: [],
        grades_spring: [],
        grades_summer: [],
        college_grading_system_alphabet: false,
        college_grading_system_100: false,
        college_grading_system_7: false,
        college_grading_system_other: false,
        lowest_number_grade: '',
        highest_number_grade: '',
        other_grading_system: '',
        isStillAttendingThisCollege: false,
        id: '',
      };
    }
  } catch (ex) {
    console.log('Error:', ex);
  }
  return initialCollegeValues;
};

interface Props {
  handleSave: (value: any) => void;
  item: any;
  indexText: string;
  index: number;
  expandAll?: boolean;
  handleExpandActive: (value: any) => void;
  check?: any;
  indexExpand?: any;
  isMobile?: boolean;
  onRemove?: () => void;
  disabled?: boolean;
}

const CollegeConfig = (props: Props) => {
  const { check, isMobile = false, disabled = false } = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [openMenu, setOpenMenu] = React.useState(false);
  const [showNotFound, setShowNotFound] = React.useState(false);
  const [expanded, setExpanded] = React.useState(props.expandAll || false);
  const [searchInput, setSearchInput] = React.useState('');
  const states = React.useMemo(() => {
    return loadStates();
  }, []);
  const earnDegreeYearsOptions = React.useMemo(() => {
    return earnDegreeYears;
  }, []);
  const MIN_YEAR = 2000;

  const getEditMask = (item: any) => {
    let mask: MaskEditCollegeInfo = {
      ceeb: true,
      name: true,
      school_type: true,
      city: true,
      state: true,
      zip: true,
      country: true,
    };

    if (item) {
      if (item.hasOwnProperty('match_all')) {
        mask.ceeb = false;
        mask.name = false;
        if (item.match_all) {
          mask.school_type = false;
          mask.city = false;
          mask.state = false;
          mask.zip = false;
          mask.country = false;
        } else {
          mask.school_type = false;
          mask.city = false;
          mask.state = false;
          mask.zip = false;
          mask.country = false;
          if (item.hasOwnProperty('ceeb') && (item.ceeb === null || item.ceeb?.trim() === '')) {
            mask.ceeb = true;
          }
          if (
            item.hasOwnProperty('school_type') &&
            (item.school_type === null || (item.school_type && item.ceeb?.trim() === ''))
          ) {
            mask.school_type = true;
          }
          if (item.hasOwnProperty('city') && (item.city === null || item.city?.trim() === '')) {
            mask.city = true;
          }
          if (item.hasOwnProperty('state') && (item.state === null || item.state?.trim() === '')) {
            mask.state = true;
          }
          if (item.hasOwnProperty('zip') && (item.zip === null || item.zip?.trim() === '')) {
            mask.zip = true;
          }
          if (
            item.hasOwnProperty('country') &&
            (item.country === null || item.country?.trim() === '')
          ) {
            mask.country = true;
          }

          // old school object
          if (item.hasOwnProperty('zip-code') && (item.zip === null || item.zip?.trimm() === '')) {
            mask.zip = true;
          }
        }
      }
    }
    return mask;
  };
  const isNewItem = () => {
    let mask = getEditMask(props.item.school);
    return (
      !(
        mask.ceeb &&
        mask.name &&
        mask.school_type &&
        mask.city &&
        mask.state &&
        mask.zip &&
        mask.country
      ) && props.item.school?.name === ''
    );
  };
  const initEditMask = () => {
    return isNewItem()
      ? {
          ceeb: false,
          name: false,
          school_type: false,
          city: false,
          state: false,
          zip: false,
          country: false,
        }
      : {
          ceeb: true,
          name: true,
          school_type: true,
          city: true,
          state: true,
          zip: true,
          country: true,
        };
  };
  const [editMask, setEditMask] = React.useState<MaskEditCollegeInfo>(initEditMask());
  const [editManual, setEditManual] = React.useState(false);
  const [collegeData, setCollegeData] = React.useState<any[] | undefined>(undefined);
  const [selectedEducation, setSelectedEducation] = React.useState<any>();
  const optionWhere = [
    { value: 'IN_CA', label: 'In California' },
    { value: 'OUTSIDE_CA', label: 'Outside California (in the U.S.)' },
    { value: 'OUTSIDE_USA', label: 'Outside the U.S.' },
  ];
  const [openFormCreate, setOpenFormCreate] = React.useState(false);
  const [gradeOptions, setGradeOptions] = React.useState<any[]>([]);
  const [collegeName, setCollegeName] = React.useState(props.item.college_name);

  // ModalConfirm state for college removal
  const [openConfirm, setOpenConfirm] = React.useState(false);

  const handleClose = () => {
    setOpenConfirm(false);
  };

  const handleConfirm = () => {
    if (props.onRemove) {
      props.onRemove();
    }
    setOpenConfirm(false);
  };

  let searchCtrl = new AbortController();
  const validationSchema = Yup.object().shape({
    fromDate: Yup.string()
      .nullable()
      .required('From Date is required')
      .test('is-valid-date', 'Invalid date', function (value: any) {
        if (!value) {
          return false;
        }

        let year = moment(value).format('yyyy');
        if (Number(year) < MIN_YEAR) return false;

        return moment(value).isValid();
      }),
    toDate: Yup.string()
      .nullable()
      .required('To Date is required')
      .test('is-valid-date', 'Invalid date', function (value: any) {
        if (!value) {
          return false;
        }

        let year = moment(value).format('yyyy');
        if (Number(year) < MIN_YEAR) return false;

        return moment(value).isValid();
      })
      .test('is-after-from-date', 'To Date cannot be before From Date', function (value) {
        const { fromDate } = this.parent;
        // Assuming dates are strings in a consistent format, e.g., 'YYYY-MM-DD'
        return moment(value).isAfter(moment(fromDate));
      }),
    other_grading_system: Yup.string().when('college_grading_system_other', {
      is: true,
      then: (schema) => schema.required('Field is required'),
    }),
  });

  const formItem = useFormik({
    initialValues: initItem(props.item),
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.handleSave({ ...values });
    },
  });

  const isLinkedCollegeRecord = (school: any) => {
    if (!school || school.is_manual) return false;
    const hasIdentity =
      !!school.id ||
      (school.ceeb !== undefined && school.ceeb !== null && String(school.ceeb).trim() !== '') ||
      (school.fib_code !== undefined &&
        school.fib_code !== null &&
        String(school.fib_code).trim() !== '');
    return hasIdentity && !!school.name;
  };

  const handleChangeItem = (item: any) => {
    try {
      setCollegeData([]);
      let college: any = Object.assign({}, item);
      college.is_manual = false;
      // Keep match_all true when API returns a full record so autofill stays linked
      if (college.match_all === undefined || college.match_all === null) {
        college.match_all = !!(college.id || college.ceeb || college.fib_code);
      }
      //console.log('college: ', college);
      setSelectedEducation(college);
      setEditMask(getEditMask(college));
      setCollegeName(college.name);
      setOpenMenu(false);
      setSearchInput('');

      // #region bulk update values:
      let newValues = Object.assign({}, formItem.values);
      newValues.college_name = college?.name;
      newValues.college_ceeb = college?.ceeb;
      newValues.college_zip_code = college?.zip;
      newValues.college_state = college?.state;
      newValues.college_city = college?.city;
      newValues.college_country = college?.country;
      newValues.csu_name = college?.csu_name;
      newValues.college_info.college_name = college?.name;
      newValues.college_info.state = college?.state;
      newValues.college_info.country = college?.country;
      newValues.school = college;
      formItem.setValues(newValues);
      // #endregion

      setEditManual(true);
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  const handleExpandClick = () => {
    const value = !expanded;
    setExpanded(value);
    props.handleExpandActive(value);
  };

  React.useEffect(() => {
    try {
      setCollegeData(undefined);
      let isNew = isNewItem();

      //#region fix old record
      if (props.item?.college_info?.where_attend_college === 'In California') {
        props.item.college_info.where_attend_college = 'IN_CA';
      } else if (
        props.item?.college_info?.where_attend_college === 'Outside California (in the U.S.)'
      ) {
        props.item.college_info.where_attend_college = 'OUTSIDE_CA';
      } else if (props.item?.college_info?.where_attend_college === 'Outside the U.S.') {
        props.item.college_info.where_attend_college = 'OUTSIDE_USA';
      }
      //#endregion

      if (props.item) {
        if (props.item.school) {
          if (props.item.school.is_manual) {
            setEditManual(true);
            setSelectedEducation(undefined);
          } else if (isLinkedCollegeRecord(props.item.school)) {
            // Restore linked college even when `id` was dropped from older saves
            handleChangeItem(props.item.school);
            setEditMask(getEditMask(props.item.school));
          } else if (props.item.school.name) {
            // Has a name but not a DB link — treat as manual entry
            setEditManual(true);
            setSelectedEducation(undefined);
            setCollegeName(props.item.school.name);
          } else {
            setEditManual(false);
          }
        } else {
          setEditManual(false);
        }

        formItem.resetForm({
          values: {
            ...formItem.values,
            ...props.item,
            grades: Array.isArray(props.item?.grades) ? props.item?.grades : [props.item?.grades],
            grades_fall: Array.isArray(props.item?.grades_fall)
              ? props.item?.grades_fall
              : [props.item?.grades_fall],
            grades_winter: Array.isArray(props.item?.grades_winter)
              ? props.item?.grades_winter
              : [props.item?.grades_winter],
            grades_spring: Array.isArray(props.item?.grades_spring)
              ? props.item?.grades_spring
              : [props.item?.grades_spring],
            grades_summer: Array.isArray(props.item?.grades_summer)
              ? props.item?.grades_summer
              : [props.item?.grades_summer],
            school: props.item.school
              ? {
                  ...props.item.school,
                  // Never flip a linked record to manual on reload
                  is_manual: props.item.school.is_manual
                    ? true
                    : !isLinkedCollegeRecord(props.item.school),
                }
              : formItem.values.school,
          },
        });
      }

      if (isNew) {
        setEditMask({
          ceeb: false,
          name: false,
          school_type: false,
          city: false,
          state: false,
          zip: false,
          country: false,
        });
        setEditManual(false);
      }
    } catch (ex) {
      console.log('Error:', ex);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    try {
      if (moment(formItem.values.fromDate).isValid() && moment(formItem.values.toDate).isValid()) {
        let fromYear = moment(formItem.values.fromDate).format('yyyy');
        if (Number(fromYear) < MIN_YEAR) return;

        let toYear = moment(formItem.values.toDate).format('yyyy');
        if (Number(toYear) < MIN_YEAR) return;

        let fromDateYear = Number(fromYear);
        let toDateYear = Number(toYear);
        if (fromYear && toDateYear) {
          let dateRange = toDateYear - fromDateYear + 1;
          if (dateRange > 0) {
            const newGradeOptions = optionValues2(dateRange).map((item) => {
              return { value: item.value + fromDateYear };
            });
            setGradeOptions(['', ...newGradeOptions]);
          }
        }
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  }, [formItem.values.fromDate, formItem.values.toDate]);

  const elementRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (check && props.indexExpand === props.index + 1) {
      setExpanded(true);

      setTimeout(() => {
        if (elementRef.current) {
          elementRef.current.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
          });
        }
      }, 100);
    } else {
      setExpanded(props.expandAll || false);
    }
  }, [props.expandAll]);

  const handleGetCollege = async (keyword: string) => {
    try {
      if (keyword && keyword.length > 0) {
        setCollegeData([]);
        setShowNotFound(false);
        if (keyword?.trim().length === 0) return;
        searchCtrl.abort();
        searchCtrl = new AbortController();
        setIsLoading(true);
        let res: any = await collegeServices.searchCollege(
          keyword,
          formItem.values.college_info.state,
          formItem.values.college_info.country,
          formItem.values.college_info.where_attend_college,
          searchCtrl
        );
        const data = res.map((item: any) => ({
          ...item,
          id: item.id,
          label: item.name,
          value: item.name,
        }));

        if (res && res.length === 0) {
          setShowNotFound(true);
        } else {
          setShowNotFound(false);
        }

        setCollegeData(data);
        setIsLoading(false);
        setOpenMenu(true);
      }
    } catch (ex) {
      console.log('Error: ', ex);
    }
  };

  const handleSearchCollege = debounce((keyword: string) => {
    defer(() => {
      handleGetCollege(keyword);
    });
  }, 500);

  const handleAliasValue = (value: string) => {
    if (value) {
      try {
        let keyword = value?.toLowerCase()?.trim();
        // search keyword as alias name
        for (let i = 0; i < AliasNames.length; i++) {
          if (keyword === AliasNames[i].alias) {
            return AliasNames[i].name;
          }
        }
      } catch (ex) {
        console.log('Error:', ex);
      }
    }
    return value;
  };

  const handleAddTerm = () => {
    if (formItem.values.grades.length > 3) return;
    formItem.setFieldValue('grades', [...formItem.values.grades, ' ']);
    formItem.setFieldValue('grades_fall', [...formItem.values.grades_fall, ' ']);
    formItem.setFieldValue('grades_winter', [...formItem.values.grades_winter, ' ']);
    formItem.setFieldValue('grades_summer', [...formItem.values.grades_summer, ' ']);
    formItem.setFieldValue('grades_spring', [...formItem.values.grades_spring, ' ']);
  };

  const handleRemoveTerm = (index: number) => {
    formItem.setFieldValue(
      'grades',
      formItem.values.grades.filter((item: any, i: number) => i !== index)
    );
    formItem.setFieldValue(
      'grades_fall',
      formItem.values.grades_fall.filter((item: any, i: number) => i !== index)
    );
    formItem.setFieldValue(
      'grades_winter',
      formItem.values.grades_winter.filter((item: any, i: number) => i !== index)
    );
    formItem.setFieldValue(
      'grades_summer',
      formItem.values.grades_summer.filter((item: any, i: number) => i !== index)
    );
    formItem.setFieldValue(
      'grades_spring',
      formItem.values.grades_spring.filter((item: any, i: number) => i !== index)
    );
  };

  const resetCollegeInfo = () => {
    // #region bulk set values
    let newValues = Object.assign({}, formItem.values);
    newValues.school.ceeb = '';
    newValues.school.fib_code = '';
    newValues.school.name = '';
    newValues.school.school_type = null;
    newValues.school.city = '';
    newValues.school.state = '';
    newValues.school.zip = '';
    newValues.school.country = '';
    newValues.school.csu_name = '';
    newValues.school.uc_name = '';
    newValues.school.cm_name = '';
    newValues.school.match_all = false;
    newValues.school.value = '';
    newValues.school.label = '';
    newValues.school.code = null;
    newValues.school.is_manual = true;
    newValues.college_name = '';
    newValues.college_ceeb = '';
    newValues.college_zip_code = '';
    newValues.college_state = '';
    newValues.college_city = '';
    newValues.college_country = '';
    newValues.csu_name = '';
    newValues.college_info.college_name = '';
    newValues.college_info.state = '';
    newValues.college_info.country = '';
    formItem.setValues(newValues);
    //#endregion
  };

  const handleSaveCollege = (values: any) => {
    formItem.setFieldValue('college_code', values?.ceeb);
    formItem.setFieldValue('college_city', values?.city);
    formItem.setFieldValue('college_ceeb', values?.ceeb);

    formItem.setFieldValue('csu_name', values?.csu_name);
    if (!values?.csu_name || values?.csu_name.length === 0) {
      formItem.setFieldValue('csu_name', values?.label);
    }
    setOpenFormCreate(false);
  };

  const buildHeader = () => {
    const title = formItem.values.college_name;
    const details = [];

    if (formItem.values?.college_ceeb) {
      details.push(`CEEB: ${formItem.values.college_ceeb}`);
    }

    // Add date range if both fromDate and toDate are available
    if (formItem.values?.fromDate && formItem.values?.toDate) {
      details.push(
        `${formatDate(formItem.values.fromDate, 'MM/DD/YYYY')} to ${formatDate(
          formItem.values.toDate,
          'MM/DD/YYYY'
        )}`
      );
    }
    // Add only fromDate if toDate is not available
    else if (formItem.values?.fromDate) {
      details.push(`${formatDate(formItem.values.fromDate, 'MM/DD/YYYY')}`);
    }

    return details.length > 0 ? `${title} - ${details.join(' - ')}` : title;
  };

  const onChangeWhereAttend = (e: any) => {
    try {
      const CA = 'California';

      switch (e.target.value) {
        case 'IN_CA':
          if (formItem.values.school?.state !== CA) {
            setSelectedEducation(undefined);
            setCollegeName('');
            handleRemove();
            formItem.setFieldValue('college_name', '');
            // formItem.setFieldValue('fullName', '');
            formItem.setFieldValue('college_city', '');
            setEditManual(false);
            setShowNotFound(false);
          }
          formItem.setFieldValue('state', CA);
          formItem.setFieldValue('country', 'United States of America');
          break;
        case 'OUTSIDE_CA':
          if (
            formItem.values.school?.state === CA ||
            formItem.values.school?.country !== 'United States of America'
          ) {
            setSelectedEducation(undefined);
            setCollegeName('');
            handleRemove();
            formItem.setFieldValue('college_name', '');
            // formItem.setFieldValue('fullName', '');
            formItem.setFieldValue('college_city', '');
            setEditManual(false);
            setShowNotFound(false);
          }
          formItem.setFieldValue('country', 'United States of America');
          break;
        case 'OUTSIDE_USA':
          if (formItem.values.school?.country === 'United States of America') {
            setSelectedEducation(undefined);
            setCollegeName('');
            handleRemove();
            formItem.setFieldValue('college_name', '');
            // formItem.setFieldValue('fullName', '');
            formItem.setFieldValue('college_city', '');
            formItem.setFieldValue('college_state', '');
            formItem.setFieldValue('college_country', '');
            setEditManual(false);
            setShowNotFound(false);
          }

          setCollegeData([]);
          break;
      }
      formItem.handleChange(e);
      setCollegeData([]);

      //console.log('formik.values.where_attend_high_school:', formItem.values.college_info.where_attend_college);
    } catch (ex) {
      console.log('Error: ', ex);
    }
  };

  const handleNotFound = (e: any) => {
    setCollegeName(searchInput);
    setShowNotFound(false);
    setEditManual(true);
    setSelectedEducation(undefined);

    // #region bulk set values
    let newValues = Object.assign({}, formItem.values);
    newValues.school.ceeb = '';
    newValues.school.fib_code = '';
    newValues.school.school_type = null;
    newValues.school.city = '';
    newValues.school.state = '';
    newValues.school.zip = '';
    newValues.school.country = '';
    newValues.school.csu_name = '';
    newValues.school.uc_name = '';
    newValues.school.cm_name = '';
    newValues.school.match_all = false;
    newValues.school.value = '';
    newValues.school.label = '';
    newValues.school.code = null;
    newValues.college_ceeb = '';
    newValues.college_zip_code = '';
    newValues.college_state = '';
    newValues.college_city = '';
    newValues.college_country = '';
    newValues.csu_name = '';
    newValues.college_info.state = '';
    newValues.college_info.country = '';

    newValues.school.name = searchInput;
    newValues.college_name = searchInput;
    newValues.school.is_manual = true;
    newValues.college_info.college_name = searchInput;
    formItem.setValues(newValues);
    //#endregion

    // resetCollegeInfo();
    // formItem.setFieldValue('school.name', searchInput);
    // formItem.setFieldValue('college_name', searchInput);
    // //// formItem.setFieldValue('fullName', searchInput);
    // formItem.setFieldValue('school.is_manual', true);
    // formItem.setFieldValue('college_info.college_name', searchInput);
    setEditMask(getEditMask(null));
  };

  const clearManualForm = () => {
    resetCollegeInfo();
    setCollegeName('');
    setEditMask(getEditMask(null));
  };

  const handleRemove = () => {
    setSelectedEducation(undefined);
    clearManualForm();
    setEditManual(false);
  };

  const checkEditMask = () => {
    return (
      editMask.ceeb ||
      editMask.name ||
      editMask.school_type ||
      editMask.city ||
      editMask.state ||
      editMask.zip ||
      editMask.country
    );
  };

  const getTerm = (indexOfGrade: number, nameTerm: string) => {
    let tempCollege: CheckCollege = {
      term: '',
      year: '',
    };
    if (nameTerm === 'Fall' && !checkEmptyValue(formItem.values.grades_fall[indexOfGrade])) {
      return (tempCollege = {
        term: 'Fall',
        year: formItem.values.grades_fall[indexOfGrade],
      });
    } else if (
      nameTerm === 'Spring' &&
      !checkEmptyValue(formItem.values.grades_spring[indexOfGrade])
    ) {
      return (tempCollege = {
        term: 'Spring',
        year: formItem.values.grades_spring[indexOfGrade],
      });
    } else if (
      nameTerm === 'Summer' &&
      !checkEmptyValue(formItem.values.grades_summer[indexOfGrade])
    ) {
      return (tempCollege = {
        term: 'Summer',
        year: formItem.values.grades_summer[indexOfGrade],
      });
    } else if (
      nameTerm === 'Winter' &&
      !checkEmptyValue(formItem.values.grades_winter[indexOfGrade])
    ) {
      return (tempCollege = {
        term: 'Winter',
        year: formItem.values.grades_winter[indexOfGrade],
      });
    }
    return tempCollege;
  };

  type CheckCollege = {
    term: string;
    year: string;
  };

  // const getCourseDataNew = (existColleges: any, term: any, checkExist: boolean) => {
  //   let courseDataNew = {
  //     collegeName: formItem.values.college_name,
  //     collegeInformation: null as any,
  //     scheduleSystem: formItem.values.college_info.type_of_term_systerm,
  //     academicYear: term.year,
  //     term: term.term,
  //     academicStatus: 'Freshman',
  //     collegeCourseArray: [],
  //   } as CollegeCourseConfigInitialType;

  //   if (checkExist) {
  //     //check term and year exist
  //     let existTerm = existColleges.find(
  //       (item: any) => item.term === term.term && item.academicYear === term.year
  //     );
  //     if (existTerm) {
  //       //term and year not exist
  //       return undefined; //return new object for push to courseArr
  //     } else {
  //       return courseDataNew; //return new object for push to courseArr
  //     }
  //   } else {
  //     return courseDataNew; //return new object for push to courseArr
  //   }
  // };

  // const saveCollegeOfGrades = async () => {
  //   try {
  //     let studentId = Cookies.get('userId');
  //     const dataLoaded = await dispatch(getGradeAndCourse(studentId)).unwrap();
  //     if (dataLoaded) {
  //       let courseArr = tryParseJSON(dataLoaded.college_course_array) ?? [];

  //       const existColleges = courseArr.filter(
  //         (item: any) => item.collegeName === formItem.values.college_name
  //       );
  //       if (existColleges.length > 0) {
  //         //exist array college course object

  //         // browse list of grades in object formItem.values
  //         let grades = formItem.values.grades;
  //         if (grades.length > 0) {
  //           for (let i = 0; i < grades.length; i++) {
  //             if (!checkEmptyValue(grades[i])) {
  //               let termFall = getTerm(i, 'Fall');
  //               if (termFall.term !== '') {
  //                 //User has input Fall term
  //                 //example grades_fall (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_fall
  //                   let existYear = formItem.values.grades_fall.find((item: any, index: number) => {
  //                     return item === formItem.values.grades_fall[i] && index !== i; //tránh lấy chính nó
  //                   });
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termFall, true);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termFall, true);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }

  //               let termSpring = getTerm(i, 'Spring');
  //               if (termSpring.term !== '') {
  //                 //User has input Spring term
  //                 //example grades_spring (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_spring
  //                   let existYear = formItem.values.grades_spring.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_spring[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termSpring, true);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termSpring, true);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //               let termSummer = getTerm(i, 'Summer');
  //               if (termSummer.term !== '') {
  //                 //User has input Summer term
  //                 //example grades_summer (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_summer
  //                   let existYear = formItem.values.grades_summer.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_summer[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termSummer, true);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termSummer, true);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //               let termWinter = getTerm(i, 'Winter');
  //               if (termWinter.term !== '') {
  //                 //User has input Winter term
  //                 //example grades_winter (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_winter
  //                   let existYear = formItem.values.grades_winter.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_winter[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termWinter, true);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termWinter, true);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         }
  //       } else {
  //         //create new college course object
  //         let courseDataNew = {
  //           collegeName: '',
  //           collegeInformation: null as any,
  //           scheduleSystem: '',
  //           academicYear: '',
  //           term: '',
  //           academicStatus: '',
  //           collegeCourseArray: [],
  //         } as CollegeCourseConfigInitialType;

  //         //browse list of grades in object formItem.values
  //         let grades = formItem.values.grades;
  //         if (grades.length > 0) {
  //           for (let i = 0; i < grades.length; i++) {
  //             if (!checkEmptyValue(grades[i])) {
  //               let termFall = getTerm(i, 'Fall');
  //               if (termFall.term !== '') {
  //                 //User has input Fall term
  //                 //example grades_fall (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_fall
  //                   let existYear = formItem.values.grades_fall.find((item: any, index: number) => {
  //                     return item === formItem.values.grades_fall[i] && index !== i;
  //                   });
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termFall, false);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termFall, false);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //               let termSpring = getTerm(i, 'Spring');
  //               if (termSpring.term !== '') {
  //                 //User has input Spring term
  //                 //example grades_spring (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_spring
  //                   let existYear = formItem.values.grades_spring.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_spring[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termSpring, false);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termSpring, false);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //               let termSummer = getTerm(i, 'Summer');
  //               if (termSummer.term !== '') {
  //                 //User has input Summer term
  //                 //example grades_summer (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_summer
  //                   let existYear = formItem.values.grades_summer.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_summer[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termSummer, false);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termSummer, false);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //               let termWinter = getTerm(i, 'Winter');
  //               if (termWinter.term !== '') {
  //                 //User has input Winter term
  //                 //example grades_winter (3) [2023, 2023, 2023]
  //                 if (i > 0) {
  //                   //index 1 đến lenghth - 1
  //                   //check year exist on formItem.values.grades_winter
  //                   let existYear = formItem.values.grades_winter.find(
  //                     (item: any, index: number) => {
  //                       return item === formItem.values.grades_winter[i] && index !== i;
  //                     }
  //                   );
  //                   if (!existYear) {
  //                     //year not exist
  //                     let data = getCourseDataNew(existColleges, termWinter, false);
  //                     if (data !== undefined) {
  //                       courseArr.push(data);
  //                     }
  //                   }
  //                 } else {
  //                   // index <= 0
  //                   let data = getCourseDataNew(existColleges, termWinter, false);
  //                   if (data !== undefined) {
  //                     courseArr.push(data);
  //                   }
  //                 }
  //               }
  //             }
  //           }
  //         } else {
  //           //set default value for new college course object
  //           courseDataNew.collegeName = formItem.values.college_name;
  //           courseDataNew.scheduleSystem = formItem.values.college_info.type_of_term_systerm;
  //           courseDataNew.academicYear = gradeOptions[1].value;
  //           courseDataNew.term = 'Fall'; //default term
  //           courseDataNew.academicStatus = 'Freshman';
  //           courseArr.push(courseDataNew);
  //         }
  //       }

  //       const newValues = {
  //         student_id: studentId,
  //         college_course_array: JSON.stringify(courseArr),
  //       };

  //       console.log('courseArr:', courseArr);
  //       console.log('newValues:', newValues);

  //       await dispatch(updateGradeAndCourse(newValues));
  //     }
  //   } catch (ex) {
  //     console.log('Error:', ex);
  //   }
  // };

  React.useEffect(() => {
    if (formItem.dirty) {
      props.handleSave(formItem.values);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formItem.values]);

  //#region Auto save function ==========
  React.useEffect(() => {
    formItem.dirty && debounceSaving();
  }, [formItem.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      formItem.handleSubmit();
    }, 1500),
    []
  );
  //#endregion ==========================

  return (
    <Card
      className="w-100 my-3 px-0 position-relative overflow"
      style={{ overflow: 'unset' }}
      key={props.indexText}
      ref={elementRef}
    >
      <CardActions
        id={`collegeItem${props.index + 1}`}
        disableSpacing
        onClick={handleExpandClick}
        sx={{
          backgroundColor: expanded ? '#AAEBF7' : 'none',
          borderBottom: expanded ? '2px solid #4D88F0' : 'none',
          marginLeft: '-8px',
        }}
        style={{ cursor: 'pointer' }}
      >
        <div
          className="w-100 d-flex px-3"
          style={{
            color: props.item.school?.is_manual ? 'black' : '#4d88f0',
            position: 'relative',
          }}
        >
          {buildHeader()}
          <strong
            className="text-field-light"
            style={{
              position: 'absolute',
              right: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              whiteSpace: 'nowrap',
            }}
          >
            {props.indexText}
          </strong>
        </div>
        <ExpandMore
          expand={expanded}
          onClick={(e) => {
            e.stopPropagation();
            handleExpandClick();
          }}
          aria-expanded={expanded}
          aria-label="show more"
          id={`btn_fold_${props.indexText.replace('/', '_')}`}
        >
          <ExpandMoreIcon />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent className="pr-5 gm-card-content" onClick={(e) => e.stopPropagation()}>
          <form id={`CollegeConfig_${props.index}`} onSubmit={formItem.handleSubmit}>
            <Row className="gm-form-fields ps-3">
              {/* <CollegeInfo formik={formItem} /> */}
              <GroupRadioButton
                name="college_info.where_attend_college"
                onChange={onChangeWhereAttend}
                values={formItem.values.college_info?.where_attend_college}
                mdCol={4}
                label="Where is the college you attended? *"
                options={optionWhere}
                isMissing={check?.college_info?.where_attend_college && check}
                verticalLayout={true}
                disabled={disabled}
              />
              {(formItem.values.college_info?.where_attend_college === 'OUTSIDE_CA' ||
                formItem.values.college_info?.where_attend_college ===
                  'Outside California (in the U.S.)') && (
                <SelectInput
                  name="college_info.state"
                  values={formItem.values.college_info?.state}
                  onChange={(e: any) => {
                    formItem.handleChange(e);
                    formItem.setFieldValue('college_state', e.target.value);
                  }}
                  label="State/U.S. territory*"
                  option={states}
                  isMissing={!formItem.values.college_info?.state && check}
                  disabled={disabled}
                />
              )}
              {(formItem.values.college_info?.where_attend_college === 'OUTSIDE_USA' ||
                formItem.values.college_info?.where_attend_college === 'Outside the U.S.') && (
                <SelectInput
                  name="college_info.country"
                  values={formItem.values.college_info?.country}
                  onChange={(e: any) => {
                    formItem.handleChange(e);
                    formItem.setFieldValue('college_country', e.target.value);
                  }}
                  label="Select a country *"
                  option={notUsCountry}
                  isMissing={!formItem.values.college_info?.country && check}
                  disabled={disabled}
                />
              )}

              <TextIconInput
                className="my-3"
                id={`collegeName_${props.index + 1}`}
                label="Search for your College / University"
                isMissing={!formItem.values.school?.name && check}
                logo="span-cm-logo"
                icon={<SearchIcon />}
                mdCol="12"
                onChange={(e: any) => {
                  let val = handleAliasValue(e.target.value);
                  setSearchInput(val);
                  handleSearchCollege(val);

                  // If a DB-linked college is already selected, search is only for finding a
                  // replacement — do NOT overwrite school/college fields (that delinks on autosave).
                  // User must Remove first, or pick a new result via handleChangeItem.
                  if (selectedEducation || isLinkedCollegeRecord(formItem.values.school)) {
                    if (val.length === 0) {
                      setCollegeData([]);
                    }
                    return;
                  }

                  setCollegeName(val);
                  formItem.setFieldValue('college_info.college_name', val);
                  formItem.setFieldValue('school.is_manual', true);
                  formItem.setFieldValue('school.name', val);
                  formItem.setFieldValue('college_name', val);
                  if (val.length === 0) {
                    setCollegeData([]);
                  }
                }}
                values={searchInput}
                otherProps={{
                  onKeyDown: (evt: any) => {
                    if (evt.key === 'Escape') {
                      setCollegeData([]);
                    }
                  },
                  onClick: (e: any) => e.stopPropagation(),
                }}
                disabled={disabled}
              />
              {isLoading && <LoadingContent />}
              {/* {collegeData !== undefined &&
              !collegeData?.length &&
              !isLoading &&
              !formItem.values.school?.name && <div className="text-center">Not found college</div>} */}
              {openMenu &&
                (collegeData || []).map((college: any, index: React.Key | null | undefined) =>
                  college?.label ? (
                    <Card className="border rounded my-1 pt-2 pb-1 gm-college-option" key={index}>
                      <div className="d-flex align-items-end position-relative cursor-pointer">
                        <div
                          className="mx-3 pb-1 text-overflow-ellipses"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleChangeItem(college);
                            // setStartSave(true);
                          }}
                        >
                          <span>{college.label}</span>
                          <span
                            className="mx-1 text-field-light sized70"
                            title={`(ceeb: ${college?.ceeb ?? ''}, city: ${
                              college?.city ?? ''
                            }, state: ${getStateName(college?.state) ?? ''}, country: ${
                              college?.country ?? ''
                            })`}
                          >
                            {`(ceeb: ${college?.ceeb ?? ''}, city: ${college?.city ?? ''}, state: ${
                              getStateName(college?.state) ?? ''
                            }, country: ${college?.country ?? ''})`}
                          </span>
                        </div>

                        <span className="position-absolute h-100 d-flex align-items-center end-0">
                          <AddIcon
                            fontSize="small"
                            className="bg-app text-primary rounded-circle mx-3 pointer"
                            style={{
                              opacity: props.disabled ? 0.5 : 1,
                              cursor: props.disabled ? 'not-allowed' : 'pointer',
                            }}
                            onClick={(e) => {
                              if (!props.disabled) {
                                e.stopPropagation();
                                handleChangeItem(college);
                              }
                              // handleChangeItem(college);
                              // setStartSave(true);
                            }}
                          />
                        </span>
                      </div>
                    </Card>
                  ) : (
                    <></>
                  )
                )}

              {showNotFound && (
                <div id="not-found" className="d-block not-found">
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn-link btn-not-found"
                      onClick={(e) =>
                        props.disabled ? undefined : (e.stopPropagation(), handleNotFound(e))
                      }
                      style={{
                        opacity: props.disabled ? 0.5 : 1,
                        cursor: props.disabled ? 'not-allowed' : 'pointer',
                      }}
                    >
                      Desired College/University not found, I want to enter my College/University
                      manually
                    </button>
                  </div>
                </div>
              )}

              <div className="my-2 text-field-light">Selected College/University</div>
              {(selectedEducation?.id ||
                selectedEducation?.ceeb ||
                selectedEducation?.fib_code ||
                isLinkedCollegeRecord(formItem.values.school)) && (
                <>
                  <div className="d-flex align-items-end position-relative">
                    <div className="mx-3 fw-bold">
                      {selectedEducation?.name || formItem.values.school?.name}
                    </div>
                    <div className="position-absolute h-100 d-flex align-items-center end-0">
                      <RemoveIcon
                        style={{
                          opacity: props.disabled ? 0.5 : 1,
                          cursor: props.disabled ? 'not-allowed' : 'pointer',
                        }}
                        fontSize="small"
                        className="bg-light text-dart rounded-circle mx-4 pointer"
                        onClick={(e) => {
                          if (!props.disabled) {
                            e.stopPropagation();
                            handleRemove();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div className="d-block mx-3 pb-3">
                    <div className="text-field-light sized70">
                      {`(ceeb: ${
                        selectedEducation?.ceeb ?? formItem.values.school?.ceeb ?? ''
                      }, fib code: ${
                        selectedEducation?.fib_code ?? formItem.values.school?.fib_code ?? ''
                      },  state: ${
                        selectedEducation?.state ?? formItem.values.school?.state ?? ''
                      }, city: ${
                        selectedEducation?.city ?? formItem.values.school?.city ?? ''
                      }, country: ${
                        selectedEducation?.country ?? formItem.values.school?.country ?? ''
                      })`}
                    </div>
                  </div>
                </>
              )}
              {(collegeData !== undefined && !collegeData?.length) ||
              !formItem.values.school?.match_all ||
              formItem.values.school?.match_all === false ? (
                <>
                  {editManual && checkEditMask() && (
                    <Row className="bg-white rounded p-3 gm-manual-form mb-4">
                      <TextInput
                        mdCol={12}
                        hidden={!editMask.name}
                        name="school.name"
                        values={collegeName}
                        onChange={(e) => {
                          try {
                            setCollegeName(e.target.value);
                            formItem.setFieldValue('school.name', e.target.value);
                            // formItem.setFieldValue('fullName', e.target.value);
                            formItem.setFieldValue('college_name', e.target.value);
                            formItem.setFieldValue('college_info.college_name', e.target.value);
                            formItem.setFieldValue('school.is_manual', true);
                          } catch (ex) {
                            console.log('Error: ', ex);
                          }
                        }}
                        label="Name of College/University"
                        countText={60}
                        isMissing={!formItem.values.school?.name && check}
                        disabled={disabled}
                      />
                      <TextInput
                        name="school.city"
                        hidden={!editMask.city}
                        values={formItem.values.school?.city}
                        onChange={(e: any) => {
                          formItem.handleChange(e);
                          formItem.setFieldValue('college_city', e.target.value);
                        }}
                        label="City"
                        countText={30}
                        disabled={disabled}
                      />
                      <SelectInput
                        className="mb-3"
                        name="school.school_type"
                        hidden={!editMask.school_type}
                        values={formItem.values.school?.school_type ?? ''}
                        onChange={(e: any) => {
                          formItem.setFieldValue('school.school_type', e.target.value);
                        }}
                        label="School Type *"
                        option={CollegeSchoolType}
                        isMissing={!formItem.values.school?.school_type && check}
                        disabled={disabled}
                      />
                      <AutocompleteInput
                        className="my-3"
                        name="school.country"
                        hidden={
                          !editMask.country ||
                          formItem.values.college_info.unlisted_type ===
                            'Unlisted French Speaking Canadian or Other Foreign Institution'
                        }
                        form={formItem}
                        defautlValues={formItem.values.school?.country?.trim() ?? ''}
                        values={formItem.values.school?.country?.trim() ?? ''}
                        label="Country/Region/Territory*"
                        option={csuCountry}
                        isMissing={!formItem.values.school?.country && check}
                        disabled={disabled}
                      />
                      {formItem.values.school?.country === 'United States of America' ? (
                        <AutocompleteInput
                          className="my-3"
                          hidden={!editMask.state}
                          option={usaState}
                          form={formItem}
                          label="State*"
                          name="school.state"
                          values={getStateName(formItem.values.school?.state)}
                          isMissing={!formItem.values.school?.state && check}
                          disabled={disabled}
                        />
                      ) : formItem.values.school?.country === 'Canada' ? (
                        <AutocompleteInput
                          className="my-3"
                          hidden={!editMask.state}
                          form={formItem}
                          option={canadaProvince}
                          label="Province*"
                          name="school.state"
                          values={formItem.values.school?.state ?? ''}
                          isMissing={!formItem.values.school?.state && check}
                          disabled={disabled}
                        />
                      ) : (
                        <TextInput
                          className="my-3"
                          name="school.state"
                          hidden={!editMask.state}
                          values={formItem.values.school?.state ?? ''}
                          onChange={(e: any) => {
                            formItem.setFieldValue('school.state', e.target.value);
                          }}
                          label="State or Province"
                          countText={30}
                          disabled={disabled}
                        />
                      )}
                      <TextInput
                        className="mb-3"
                        name="school.zip"
                        hidden={!editMask.zip}
                        values={formItem.values.school?.zip}
                        onChange={(e: any) => {
                          formItem.setFieldValue('school.zip', e.target.value);
                        }}
                        label="Zip Code*"
                        countText={10}
                        isMissing={!formItem.values.school?.zip && check}
                        disabled={disabled}
                      />
                      <TextInput
                        name="school.ceeb"
                        hidden={!editMask.ceeb}
                        values={formItem.values.school?.ceeb}
                        onChange={(e: any) => {
                          formItem.setFieldValue('school.ceeb', e.target.value);
                          formItem.setFieldValue('college_ceeb', e.target.value);
                        }}
                        label="CEEB Code"
                        countText={10}
                        disabled={disabled}
                      />
                    </Row>
                  )}
                </>
              ) : (
                <></>
              )}

              {editManual && props.item.school?.is_manual && (
                <>
                  <GroupRadioButton
                    logo="span-csu-logo"
                    name="college_info.unlisted_type"
                    onChange={formItem.handleChange}
                    values={formItem.values.college_info.unlisted_type}
                    mdCol={4}
                    label="If you can't find your school in our list, select one of the options below:"
                    options={UnlistedTypes}
                    onClear={() => {
                      formItem.setFieldValue('college_info.unlisted_type', '');
                    }}
                    disabled={disabled}
                  />

                  {formItem.values.college_info.unlisted_type ===
                    'Unlisted French Speaking Canadian or Other Foreign Institution' && (
                    <>
                      <SelectInput
                        logo="span-cm-logo"
                        name="college_info.country"
                        values={formItem.values.college_info?.country}
                        onChange={(e: any) => {
                          formItem.handleChange(e);
                          formItem.setFieldValue('college_country', e.target.value);
                          formItem.setFieldValue('school.country', e.target.value);
                        }}
                        label="Please provide your school's country:"
                        option={countryOptions}
                        disabled={disabled}
                      />
                      <Col md={6} />
                    </>
                  )}
                </>
              )}
              <div className="bs-gap">
                <div className="row bs my-3">
                  <div className="col-md-6">
                    <DatePickerInput
                      id={`fromDate_${props.index + 1}`}
                      className="mt-4"
                      label={`College "${props.index}" from date*`}
                      name="fromDate"
                      values={formItem.values.fromDate}
                      onChange={(value) => {
                        formItem.setFieldValue('fromDate', value);
                      }}
                      isMissing={!formItem.values.fromDate && check}
                      disabled={disabled}
                    />
                    {formItem.errors.fromDate && formItem.touched.fromDate && (
                      <div className="text-danger">{formItem.errors.fromDate}</div>
                    )}
                  </div>
                  <div className="col-md-6">
                    <DatePickerInput
                      id={`toDate_${props.index + 1}`}
                      className="mt-4"
                      label={`College "${props.index}" to date*`}
                      name={`toDate_${props.index + 1}`}
                      values={formItem.values.toDate}
                      onChange={(value) => formItem.setFieldValue('toDate', value)}
                      isMissing={!formItem.values.toDate && check}
                      disabled={disabled}
                    />
                    {formItem.errors.toDate && formItem.touched.toDate && (
                      <div className="text-danger">{formItem.errors.toDate}</div>
                    )}
                  </div>
                </div>
              </div>

              <CheckboxInput
                className="py-3"
                logo="span-csu-logo"
                label="Check if you are still attending this college or university"
                name="isStillAttendingThisCollege"
                values={formItem.values.isStillAttendingThisCollege}
                onChange={formItem.handleChange}
                disabled={disabled}
              />

              <Row className="common-flag mt-5">
                <GroupCheckbox
                  className="py-3"
                  verticalLayout={true}
                  label="Course Details"
                  logo="span-cm-logo"
                  options={[
                    {
                      value: 'college_is_dual_enrollment',
                      label: 'Dual enrollment with high school,',
                    },
                    {
                      value: 'college_is_credit_awarded',
                      label: 'Credit awarded directly by college ',
                    },
                    { value: 'college_is_summer_program', label: 'Summer program' },
                  ]}
                  form={formItem}
                  disabled={disabled}
                />

                <YesNoSwitch
                  className="py-3"
                  label={`Do you expect to earn a degree from ${formItem.values.college_name}? *`}
                  logo="span-cm-logo"
                  name="expect_to_earn_degree_from_San_Diego_Mesa"
                  values={formItem.values.expect_to_earn_degree_from_San_Diego_Mesa}
                  onChange={formItem.handleChange}
                  isMissing={!formItem.values.expect_to_earn_degree_from_San_Diego_Mesa && check}
                  disabled={disabled}
                />

                {formItem.values.expect_to_earn_degree_from_San_Diego_Mesa === 'true' && (
                  <Grid container spacing={2}>
                    <Grid xs={12}>
                      <GroupRadioButton
                        verticalLayout={true}
                        mdCol={12}
                        label="Degree Info*"
                        logo="span-csu-logo"
                        name="degree_info"
                        values={formItem.values.degree_info}
                        onChange={formItem.handleChange}
                        options={['Degree Awarded', 'Degree In Progress']}
                        isMissing={!formItem.values.degree_info && check}
                        disabled={disabled}
                      />
                    </Grid>
                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        logo="span-cm-logo"
                        label="Degree in progress or will be earned"
                        name="degree_earned"
                        values={formItem.values.degree_earned}
                        onChange={formItem.handleChange}
                        option={degree_earned_options}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        logo="span-csu-logo"
                        label={`Details of degree in progress or will be earned,
                      When did you earn that degree?*`}
                        name="college_info.detail_degree_earned"
                        values={formItem.values.college_info?.detail_degree_earned}
                        onChange={formItem.handleChange}
                        option={collegeDetailEarnedOption}
                        isMissing={!formItem.values.college_info?.detail_degree_earned && check}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        label="Select Month"
                        name="college_info.when_you_earn_degree_month"
                        values={formItem.values.college_info?.when_you_earn_degree_month}
                        onChange={formItem.handleChange}
                        option={month_options}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        label="Select Year"
                        name="college_info.when_you_earn_degree_year"
                        values={formItem.values.college_info?.when_you_earn_degree_year}
                        onChange={formItem.handleChange}
                        option={earnDegreeYearsOptions}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        logo="span-csu-logo"
                        label="What was your major?*"
                        name="college_info.your_major"
                        values={formItem.values.college_info?.your_major}
                        onChange={formItem.handleChange}
                        option={majorOption}
                        isMissing={!formItem.values.college_info?.your_major && check}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12} md={6} className="aligned-input-container">
                      <SelectInput
                        logo="span-csu-logo"
                        label="What was your minor?"
                        name="college_info.your_minor"
                        values={formItem.values.college_info?.your_minor}
                        onChange={formItem.handleChange}
                        option={majorOption}
                        disabled={disabled}
                      />
                    </Grid>

                    <Grid xs={12}>
                      <CheckboxInput
                        className="py-3"
                        logo="span-csu-logo"
                        label="Check if you were a double major"
                        name="college_info.have_double_major"
                        values={formItem.values.college_info?.have_double_major}
                        onChange={(e) => {
                          formItem.setFieldValue(
                            'college_info.have_double_major',
                            e.target.checked
                          );
                        }}
                        disabled={disabled}
                      />
                      {formItem.values.college_info?.have_double_major === true && (
                        <div className="aligned-input-container">
                          <SelectInput
                            logo="span-csu-logo"
                            label="Select Second Major?"
                            name="college_info.your_second_major"
                            values={formItem.values.college_info?.your_second_major}
                            onChange={formItem.handleChange}
                            option={majorOption}
                            disabled={disabled}
                          />
                        </div>
                      )}
                    </Grid>
                  </Grid>
                )}
              </Row>
              <GroupCheckbox
                className="pt-3"
                verticalLayout={true}
                label={`What is this college's grading system? *`}
                logo="span-uc-logo"
                form={formItem}
                mdCol={6}
                options={grading_system_options}
                isMissing={
                  !formItem.values.college_grading_system_alphabet &&
                  !formItem.values.college_grading_system_other &&
                  check
                }
                disabled={disabled}
              />
              {formItem.values.college_grading_system_other && (
                <>
                  <TextInput
                    className="py-3"
                    logo="span-uc-logo"
                    countText={16}
                    label="Specify the grading system *"
                    values={formItem.values.other_grading_system}
                    onChange={formItem.handleChange}
                    name="other_grading_system"
                    isMissing={!formItem.values.other_grading_system && check}
                    disabled={disabled}
                  />
                  {formItem.errors.other_grading_system &&
                    formItem.touched.other_grading_system && (
                      <div className="text-danger" style={{ position: 'relative', top: '-2.5em' }}>
                        {formItem.errors.other_grading_system}
                      </div>
                    )}
                </>
              )}
              <GroupRadioButton
                className="py-3"
                label="What type of term system does this college or university use?*"
                logo="span-csu-logo"
                options={type_of_term_systerm_options}
                values={formItem.values.college_info?.type_of_term_systerm}
                onChange={formItem.handleChange}
                name="college_info.type_of_term_systerm"
                isMissing={!formItem.values.college_info?.type_of_term_systerm && check}
                verticalLayout={true}
                disabled={disabled}
              />
              <GroupRadioButton
                className="py-3"
                label="What is this college's term system?"
                logo="span-uc-logo"
                options={type_of_term_systerm_uc_options}
                values={formItem.values.college_info?.type_of_term_systerm_uc}
                onClear={() => formItem.setFieldValue('college_info.type_of_term_systerm_uc', '')}
                onChange={formItem.handleChange}
                name="college_info.type_of_term_systerm_uc"
                verticalLayout={true}
                disabled={disabled}
              />

              <GroupRadioButton
                label="What was your tuition status (resident or non-resident) at this college or university during the last term you attended?*"
                options={tuition_status_options}
                values={formItem.values.college_info?.your_tuition_status}
                onChange={formItem.handleChange}
                name="college_info.your_tuition_status"
                isMissing={!formItem.values.college_info?.your_tuition_status && check}
                verticalLayout={true}
                disabled={disabled}
              />
              <div className="gm-grades-section mt-3">
                <div className="gm-section-subtitle">
                  <p
                    className={`gm-grades-title ${
                      formItem.values.grades.length === 0 ? 'gm-missing-field' : ''
                    }`}
                  >
                    During which grades and terms did you attend this college?
                  </p>
                </div>

                {(formItem.values.grades ?? []).map((item, index) => (
                  <div key={index} className="gm-grade-term-row">
                    <Grid container spacing={2} className="gm-grade-term-grid">
                      <Grid xs={12} md={2}>
                        <SelectInput
                          logo="span-uc-logo"
                          isSatTest={true}
                          form={formItem}
                          option={grade_options}
                          label="Grades*"
                          name={`grades[${index}]`}
                          values={formItem.values.grades[index]}
                          onChange={(e: any) => {
                            formItem.setFieldValue(`grades[${index}]`, e.target.value);
                          }}
                          isMissing={!formItem.values.grades[index] && check}
                          disabled={disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={2}>
                        <SelectInput
                          form={formItem}
                          option={gradeOptions}
                          label="Fall"
                          name={`grades_fall[${index}]`}
                          values={formItem.values.grades_fall[index]}
                          onChange={(e: any) => {
                            formItem.setFieldValue(`grades_fall[${index}]`, e.target.value);
                          }}
                          disabled={disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={2}>
                        <SelectInput
                          form={formItem}
                          option={gradeOptions}
                          label="Winter"
                          name={`grades_winter[${index}]`}
                          values={formItem.values.grades_winter[index]}
                          onChange={(e: any) => {
                            formItem.setFieldValue(`grades_winter[${index}]`, e.target.value);
                          }}
                          disabled={disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={2}>
                        <SelectInput
                          form={formItem}
                          option={gradeOptions}
                          label="Spring"
                          name={`grades_spring[${index}]`}
                          values={formItem.values.grades_spring[index]}
                          onChange={(e: any) => {
                            formItem.setFieldValue(`grades_spring[${index}]`, e.target.value);
                          }}
                          disabled={disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={2}>
                        <SelectInput
                          form={formItem}
                          option={gradeOptions}
                          label="Summer"
                          name={`grades_summer[${index}]`}
                          values={formItem.values.grades_summer[index]}
                          onChange={(e: any) => {
                            formItem.setFieldValue(`grades_summer[${index}]`, e.target.value);
                          }}
                          disabled={disabled}
                        />
                      </Grid>

                      <Grid xs={12} md={2} className="gm-remove-term-container">
                        <div className="gm-remove-term-wrapper">
                          <button
                            type="button"
                            className="gm-remove-term-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveTerm(index);
                            }}
                            title="Remove this term"
                            disabled={disabled}
                          >
                            <RemoveIcon className="gm-remove-icon" />
                            <span>Remove</span>
                          </button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                ))}

                {formItem.values.grades.length < 4 && (
                  <div className="gm-add-term-section">
                    <div className="gm-add-term-info">
                      <span className="gm-add-term-text">You can add up to 4 term/year</span>
                    </div>
                    <Button
                      variant="primary"
                      className="p-2 px-5"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleAddTerm();
                      }}
                      disabled={disabled}
                    >
                      Add another term/year
                    </Button>
                  </div>
                )}
              </div>

              <Col xs={6} md={9} />
              <Col xs={6} md={3} className="p-3">
                <Button
                  className="w-100 btn-save-info"
                  onClick={(e) => {
                    e.stopPropagation();
                    formItem.handleSubmit();
                    if (formItem.isValid) {
                      setExpanded(false);
                    }
                  }}
                  disabled={disabled}
                >
                  Save Info
                </Button>
              </Col>
            </Row>
          </form>
        </CardContent>
      </Collapse>

      <RemoveCircleOutlineIcon
        className="position-absolute text-field-light pointer"
        style={{
          right: '-24px',
          top: '12px',
          opacity: props.disabled ? 0.5 : 1,
          cursor: props.disabled ? 'not-allowed' : 'pointer',
        }}
        onClick={props.disabled ? undefined : props.onRemove}
      />

      <FormCreateCollegeModal
        open={openFormCreate}
        onClose={() => setOpenFormCreate(false)}
        handleSave={handleSaveCollege}
      />
      <ModalConfirm
        open={openConfirm}
        handleClose={handleClose}
        handleConfirm={handleConfirm}
        title=""
        message="Are you sure you want to remove this college?"
        confirmText="Remove"
        cancelText="Cancel"
      />
      <style scoped>{` 
button.btn-link.btn-not-found {
  color: #0d6efd!important;
  border: none!important;
  background: transparent;
  text-decoration: underline!important;
  text-decoration-color: #0d6efd!important;
  font-weight: 300;
  text-decoration-style: solid;
}
.text-overflow-ellipses {
  white-space: nowrap!important;
  overflow: hidden!important;
  text-overflow: ellipsis!important;
  padding-right:1.5625rem;
  cursor: pointer;
  caret-color: transparent; 
}
.cursor-pointer {
  cursor: pointer;
}
      `}</style>
    </Card>
  );
};

export default CollegeConfig;
